import { STATUS_COLORS, STATUS_LABELS } from "@/lib/status";
import { Check, X } from "lucide-react";

const COMPACT_ICONS = {
  completed: Check,
  cancelled: X,
};

export function TripStatusPill({ status, compact = false }) {
  const color = STATUS_COLORS[status] || "#9CA3AF";
  const Icon = compact ? COMPACT_ICONS[status] : null;
  if (Icon) {
    return (
      <span
        className="inline-flex items-center justify-center w-5 h-5 rounded-full border"
        style={{ borderColor: color, color, background: `${color}20` }}
        data-testid={`trip-status-${status}`}
        title={STATUS_LABELS[status] || status}
      >
        <Icon className="w-3 h-3" strokeWidth={3} />
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-widest border"
      style={{ borderColor: color, color }}
      data-testid={`trip-status-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: color }} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function DriverStatusPill({ status }) {
  const map = {
    free:    { color: "#10B981", label: "Libre",    glow: "glow-green" },
    busy:    { color: "#F59E0B", label: "Ocupado",  glow: "glow-amber" },
    offline: { color: "#6B7280", label: "Offline",  glow: "" },
  };
  const cfg = map[status] || map.offline;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-widest border"
      style={{ borderColor: cfg.color, color: cfg.color }}
      data-testid={`driver-status-${status}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.glow}`} style={{ background: cfg.color }} />
      {cfg.label}
    </span>
  );
}
